// Module
var code = "<svg viewBox=\"0 0 515.556 515.556\" xmlns=\"http://www.w3.org/2000/svg\">\r\n  <path d=\"M386.671 257.778L128.893 515.556V386.67l128.889-128.892-128.897-128.886L128.893 0z\"/>\r\n</svg>\r\n";
// Exports
module.exports = code;